import Grid from '@material-ui/core/Grid';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { PeAutocompleteOptionsProps } from '@pe-libs/react-components/build/components/PeAutocomplete/types';
import PeFormAutocomplete from '@pe-libs/react-components/build/components/PeFormAutocomplete';
import PeFormTextField from '@pe-libs/react-components/build/components/PeFormTextField';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'universal-cookie';
import { getUserLocale } from '#modules/app/selectors/settings';
import { industries } from '#modules/auth/actions/onboarding';
import { getIndustriesData } from '#modules/auth/selectors';
import { createIndustrySelect } from './helper';
import messages, { messagesIndustries } from './messages';
import Buttons from './pageElements/PeOnboardingButtons';
import OnboardingIntro from './pageElements/PeOnboardingIntro';
import Stepper from './pageElements/PeOnboardingStepper';
import useStyles from './styles';
import { OnboardingStepType } from './types';

const PeOnboardingPage3: OnboardingStepType = ({ formik, wizardMethods, actions }) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const formatMessage = useIntlMessage();
  const isOtherIndustry = formik.values.page3.profileIndustry === 'profileIndustryCustom';
  const cookies = new Cookies();
  const locale = useSelector(getUserLocale)?.toLowerCase() ?? (cookies.get('registerlocale') as string);
  const data = useSelector(getIndustriesData);
  const industriesList = useMemo(() => createIndustrySelect(data), [data]);
  const industryOptions = [
    ...industriesList,
    {
      labelId: 'profileIndustryCustom',
      title: formatMessage(messagesIndustries.other),
      value: 'profileIndustryCustom',
    },
  ];

  const filterOptions = createFilterOptions({
    stringify: (option: PeAutocompleteOptionsProps) => {
      if (option.aliases && option.aliases.length > 0) {
        return [option.title, ...option.aliases].join(' ');
      }

      return option.title as string;
    },
  });

  useEffect(() => {
    dispatch(industries());
  }, [locale]);

  return (
    <Grid container={true} spacing={3}>
      <Grid item={true} xs={12}>
        <OnboardingIntro title={formatMessage(messages.titlestep3)} desc={formatMessage(messages.descstep3)} />
        <Stepper {...wizardMethods} actions={actions} />
      </Grid>
      <Grid item={true} xs={12}>
        <PeFormAutocomplete
          options={industryOptions}
          filterOptions={filterOptions}
          formik={{
            ...formik,
            handleChange: (event: { target: { value: string } }) => {
              formik.setFieldTouched('page3.profileIndustryCustom', false);
              formik.setFieldValue('page3.profileIndustry', event.target.value);
            },
          }}
          name="page3.profileIndustry"
          id="profileIndustry"
          label={`${formatMessage(messages.industrylabel)}*`}
          noOptionsText={formatMessage(messages.noOptionsText)}
        />
      </Grid>
      {isOtherIndustry && (
        <Grid item={true} xs={12}>
          <PeFormTextField
            formik={formik}
            type="text"
            name="page3.profileIndustryCustom"
            label={`${formatMessage(messages.industrylabelother)}*`}
          />
        </Grid>
      )}
      <div className={styles.requiredText}>{formatMessage(messages.required)}</div>
      <Buttons {...wizardMethods} />
    </Grid>
  );
};

export default PeOnboardingPage3;
